
import { ChangeEvent, InputHTMLAttributes, FC } from 'react'
interface TextInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  label?: string
  value?: string | null
  handleOnChange: (value: string) => void
}

const TextInput: FC<TextInputProps> = ({ label, value, handleOnChange, ...props }) => {
  const safeValue = typeof value === 'string' ? value : (value == null ? '' : String(value))

  return (
    <div className='flex flex-column'>
      {label !== undefined && label !== '' && <label className='mb2 f6 grey'>{label}</label>}
      <input
        type='text'
        className='h2 pt2 ph4 br2 ba b--bright-grey bg-white f5 flex items-center w-100'
        value={safeValue}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleOnChange(e.target.value)}
        {...props}
      />
    </div>
  )
}

export default TextInput
